{
  "categories": {
    "all": "Tất cả danh mục"
  },

  "categoryCatalog": {
    "pages": {
      "title": "Nhóm dịch vụ",
      "permissionDenied": "Bạn không có quyền xem nhóm dịch vụ."
    },
    "search": {
      "placeholder": "Tìm theo tên hoặc mã…"
    },
    "actions": {
      "add": "Thêm nhóm",
      "addQuick": "Thêm danh mục",
      "manage": "Quản lý"
    },
    "fields": {
      "name": "Tên nhóm",
      "categoryCode": "Mã nhóm",
      "itemCount": "Số dịch vụ",
      "createdAt": "Ngày tạo",
      "status": "Trạng thái"
    },
    "form": {
      "name": "Tên danh mục"
    },
    "quickCreate": {
      "namePlaceholder": "Ví dụ: Nha chu"
    },
    "status": {
      "active": "Đang dùng",
      "inactive": "Ngừng dùng"
    },
    "dialogs": {
      "addTitle": "Thêm nhóm dịch vụ",
      "editTitle": "Sửa nhóm dịch vụ",
      "manageTitle": "Quản lý nhóm dịch vụ"
    },
    "table": {
      "empty": "Chưa có nhóm dịch vụ",
      "noFound": "Không tìm thấy nhóm dịch vụ phù hợp"
    },
    "validation": {
      "nameRequired": "Vui lòng nhập tên danh mục"
    },
    "toasts": {
      "created": "Đã tạo nhóm dịch vụ",
      "updated": "Đã cập nhật nhóm dịch vụ",
      "deactivated": "Đã ngừng dùng nhóm dịch vụ",
      "saveFailed": "Không lưu được nhóm dịch vụ",
      "deactivateFailed": "Không ngừng dùng được nhóm dịch vụ",
      "loadFailed": "Không tải được danh sách nhóm dịch vụ"
    },
    "history": {
      "empty": "Chưa có lịch sử thay đổi cho nhóm này."
    }
  },

  "uomCatalog": {
    "pages": {
      "title": "Đơn vị tính dịch vụ",
      "permissionDenied": "Bạn không có quyền xem đơn vị tính dịch vụ."
    },
    "search": {
      "placeholder": "Tìm theo tên hoặc mã…"
    },
    "actions": {
      "add": "Thêm đơn vị",
      "addQuick": "Thêm đơn vị tính"
    },
    "fields": {
      "name": "Tên đơn vị",
      "code": "Mã",
      "sortOrder": "Thứ tự",
      "status": "Trạng thái"
    },
    "form": {
      "name": "Tên đơn vị",
      "sortOrder": "Thứ tự hiển thị"
    },
    "quickCreate": {
      "namePlaceholder": "Ví dụ: Răng"
    },
    "status": {
      "active": "Đang dùng",
      "inactive": "Ngừng dùng"
    },
    "dialogs": {
      "addTitle": "Thêm đơn vị tính",
      "editTitle": "Sửa đơn vị tính"
    },
    "table": {
      "empty": "Chưa có đơn vị tính",
      "noFound": "Không tìm thấy đơn vị tính phù hợp"
    },
    "validation": {
      "nameRequired": "Vui lòng nhập tên đơn vị tính"
    },
    "toasts": {
      "created": "Đã tạo đơn vị tính",
      "updated": "Đã cập nhật đơn vị tính",
      "deactivated": "Đã ngừng dùng đơn vị tính",
      "saveFailed": "Không lưu được đơn vị tính",
      "deactivateFailed": "Không ngừng dùng được đơn vị tính",
      "loadFailed": "Không tải được danh sách đơn vị tính"
    }
  },

  "journalCatalog": {
    "pages": {
      "title": "Nhật ký điều trị",
      "permissionDenied": "Bạn không có quyền xem danh mục nhật ký điều trị."
    },
    "search": {
      "placeholder": "Tìm theo tên…"
    },
    "actions": {
      "add": "Thêm mục nhật ký",
      "addVisit": "Thêm nhật ký",
      "addLine": "Thêm dòng"
    },
    "fields": {
      "name": "Tên mục",
      "sortOrder": "Thứ tự",
      "status": "Trạng thái",
      "countsTowardKpi": "Đếm vào bảng việc",
      "countMode": "Cách đếm",
      "usesAssistantRings": "Kíp 2 vòng",
      "journalItem": "Mục nhật ký",
      "journalColumn": "Nhật ký điều trị",
      "duration": "Thời gian",
      "lines": "Nhật ký điều trị",
      "splitStaff": "Bác sĩ và phụ tá theo từng mục",
      "treatmentPlan": "Kế hoạch điều trị",
      "performedService": "Dịch vụ đã làm",
      "performedQuantity": "Số lượng",
      "performedQuantityShort": "SL"
    },
    "countMode": {
      "none": "Không đếm",
      "visit": "Đếm lần",
      "duration": "Đếm thời gian"
    },
    "form": {
      "name": "Tên mục nhật ký",
      "sortOrder": "Thứ tự hiển thị",
      "countsTowardKpi": "Đếm vào bảng việc",
      "usesAssistantRings": "Kíp 2 vòng (phụ tá vòng trong / vòng ngoài)"
    },
    "placeholders": {
      "name": "Ví dụ: Khám lần đầu",
      "journalItem": "Chọn mục nhật ký",
      "durationMinutes": "Ví dụ: 30 phút",
      "treatmentPlan": "Chọn kế hoạch điều trị",
      "performedService": "Chọn dịch vụ trên kế hoạch",
      "performedQuantity": "Ví dụ: 3"
    },
    "status": {
      "active": "Đang dùng",
      "inactive": "Ngừng dùng",
      "countsYes": "Có",
      "countsNo": "Không",
      "ringsYes": "Có",
      "ringsNo": "Không"
    },
    "dialogs": {
      "addTitle": "Thêm mục nhật ký điều trị",
      "editTitle": "Sửa mục nhật ký điều trị",
      "addVisitTitle": "Ghi nhật ký điều trị",
      "editVisitTitle": "Sửa nhật ký điều trị"
    },
    "table": {
      "empty": "Chưa có mục nhật ký điều trị",
      "noFound": "Không tìm thấy mục nhật ký phù hợp",
      "emptyVisits": "Chưa có nhật ký điều trị",
      "needsTreatmentPlan": "Tạo ít nhất một kế hoạch điều trị trước khi ghi nhật ký",
      "durationMinutes": "{{count}} phút",
      "treatmentTask": "Công tác điều trị",
      "durationLabel": "Thời lượng",
      "assistantColumn": "Phụ tá",
      "innerRingColumn": "Vòng trong",
      "outerRingColumn": "Vòng ngoài"
    },
    "validation": {
      "nameRequired": "Vui lòng nhập tên mục nhật ký",
      "journalRequired": "Vui lòng chọn mục nhật ký",
      "dateRequired": "Vui lòng chọn ngày thực hiện",
      "staffRequired": "Vui lòng chọn người thực hiện",
      "lineRequired": "Vui lòng chọn mục nhật ký cho từng dòng",
      "lineStaffRequired": "Vui lòng chọn bác sĩ cho từng dòng",
      "durationRequired": "Vui lòng nhập thời gian (phút) cho mục đếm theo thời gian",
      "performedPair": "Chọn dịch vụ và nhập số lượng đã làm",
      "performedQuantityInvalid": "Số lượng đã làm phải là số nguyên từ 1",
      "performedQuantityExceeds": "Số lượng lần này vượt quá số còn lại của dịch vụ",
      "requiresTreatmentPlan": "Bệnh nhân chưa có kế hoạch điều trị. Tạo kế hoạch trước khi ghi nhật ký."
    },
    "errors": {
      "exceedsItem": "Số lượng lần này vượt quá số còn lại của dịch vụ",
      "belowRecorded": "Số lượng dịch vụ không được nhỏ hơn số đã ghi trong nhật ký",
      "notContracted": "Chỉ ghi số lượng đã làm trên dịch vụ đã xác nhận",
      "quantityRequired": "Nhập số lượng đã làm khi đã chọn dịch vụ",
      "quantityInvalid": "Số lượng đã làm phải là số nguyên từ 1",
      "planItemRequired": "Chọn dịch vụ khi đã nhập số lượng đã làm",
      "planNotFound": "Không tìm thấy kế hoạch điều trị của bệnh nhân này",
      "planMismatch": "Kế hoạch không khớp với dịch vụ đã gắn",
      "requiresTreatmentPlan": "Bệnh nhân chưa có kế hoạch điều trị. Tạo kế hoạch trước khi ghi nhật ký.",
      "commissionLocked": "Hoa hồng của buổi này đã chốt hoặc đã chi, không sửa số lượng đã làm"
    },
    "optionLabel": "{{name}} · còn {{remaining}}/{{quantity}}",
    "toasts": {
      "created": "Đã tạo mục nhật ký",
      "updated": "Đã cập nhật mục nhật ký",
      "deactivated": "Đã ngừng dùng mục nhật ký",
      "saveFailed": "Không lưu được mục nhật ký",
      "deactivateFailed": "Không ngừng dùng được mục nhật ký",
      "loadFailed": "Không tải được danh sách nhật ký",
      "visitCreated": "Đã ghi nhật ký điều trị",
      "visitCreatedMany": "Đã ghi {{count}} nhật ký điều trị",
      "visitPartial": "Đã ghi {{count}} dòng. {{message}}",
      "visitUpdated": "Đã cập nhật nhật ký điều trị",
      "visitDeleted": "Đã xóa nhật ký điều trị",
      "visitSaveFailed": "Không lưu được nhật ký điều trị",
      "visitDeleteFailed": "Không xóa được nhật ký điều trị"
    },
    "deleteVisitConfirm": "Xóa nhật ký \"{{name}}\"? Hành động này không thể hoàn tác."
  },

  "status": {
    "unconfirmed": "Chưa xác nhận",
    "confirmed": "Đã xác nhận",
    "in_progress": "Đang điều trị",
    "completed": "Hoàn thành",
    "cancelled": "Đã hủy",
    "rejected": "Từ chối",
    "unknown": "Không xác định"
  },

  "materialCoverage": {
    "complete": "Đã xuất đủ",
    "incomplete": "Thiếu xuất",
    "incompleteHint": "Chưa xuất đủ vật tư bắt buộc theo định mức"
  },

  "paymentStatus": {
    "unpaid": "Chưa thanh toán",
    "partiallyPaid": "Thanh toán một phần",
    "paid": "Đã thanh toán"
  },

  "confirmationStatus": {
    "unconfirmed": "Chưa xác nhận",
    "partial": "Xác nhận một phần",
    "confirmed": "Đã xác nhận",
    "rejected": "Từ chối"
  },

  "customerClass": {
    "new": "Mới hoàn toàn",
    "returningConsult": "Cũ tư vấn mới",
    "select": "Chọn phân loại khách hàng"
  },

  "fields": {
    "name": "Tên dịch vụ",
    "code": "Mã dịch vụ",
    "category": "Danh mục",
    "labOrderEnabled": "Cho phép tạo yêu cầu labo",
    "materialLines": "Định mức vật tư",
    "inventoryItem": "Mặt hàng kho",
    "materialQty": "Số lượng",
    "materialRequired": "Bắt buộc xuất",
    "requiredShort": "Bắt buộc",
    "assistantStaffing": "Kíp 2 vòng",
    "workPerformer": "Người làm",
    "countsTowardKpi": "Đếm vào bảng việc",
    "warrantyType": "Bảo hành",
    "warrantyMonths": "Số tháng bảo hành",
    "warrantySerial": "Số serial bảo hành",
    "completeLinkedItems": "Hoàn thành dịch vụ này",
    "defaultLabWorkType": "Loại phục hình mặc định",
    "defaultLabMaterial": "Vật liệu lab mặc định",
    "description": "Mô tả",
    "price": "Đơn giá (đ)",
    "duration": "Thời lượng (phút)",
    "uom": "Đơn vị tính",
    "notes": "Ghi chú",
    "notesPlaceholder": "VD: hẹn tái khám sau 1 tuần",
    "status": "Trạng thái",
    "paymentStatus": "Trạng thái thanh toán",
    "confirmationStatus": "Trạng thái xác nhận",
    "rejectionReason": "Lý do từ chối",
    "customerClass": "Phân loại khách hàng",
    "planCode": "Mã kế hoạch",
    "planName": "Tên kế hoạch",
    "patient": "Bệnh nhân",
    "representativeDoctor": "Bác sĩ đại diện",
    "consultant": "Bác sĩ tư vấn",
    "consultingStaff": "Nhân viên tư vấn",
    "subtotal": "Tạm tính",
    "itemDiscount": "Ưu đãi dịch vụ",
    "planDiscount": "Ưu đãi kế hoạch",
    "totalCost": "Phải thanh toán",
    "planPayableAmount": "Phải thanh toán",
    "planQuotedPayableAmount": "Dự kiến thu",
    "planQuotedGrossAmount": "Ước tính (tạm tính)",
    "unallocatedPlanAdvance": "Tạm ứng chưa gán",
    "planGrossAmount": "Tạm tính",
    "planDiscountAmount": "Tổng ưu đãi",
    "paid": "Đã trả",
    "balance": "Còn lại",
    "created": "Ngày tạo",
    "planCreatedOn": "Ngày tạo kế hoạch",
    "lastUpdated": "Cập nhật lần cuối",
    "title": "Tiêu đề",
    "clinicalContent": "Nội dung điều trị",
    "clinicalContentPlaceholder": "VD: Cạo vôi răng, đánh bóng",
    "procedure": "Quy trình",
    "teeth": "Răng (FDI)",
    "teethPlaceholder": "VD: 36, 37",
    "durationMinutes": "Thời gian (phút)",
    "assignedDentist": "Bác sĩ phụ trách",
    "performedDate": "Ngày thực hiện",
    "performingDentist": "Bác sĩ thực hiện",
    "assistant": "Phụ tá",
    "innerAssistant": "Phụ tá vòng trong",
    "outerAssistant": "Phụ tá vòng ngoài",
    "treatmentPlan": "Kế hoạch điều trị",
    "service": "Dịch vụ",
    "sessionOrder": "Thứ tự phiên",
    "recordCreated": "Ngày tạo hồ sơ",
    "none": "Không có",
    "unassigned": "Chưa chọn",
    "doctorName": "BS. {{name}}"
  },

  "discountSource": {
    "item": "Dịch vụ",
    "plan": "Kế hoạch",
    "mixed": "Hỗn hợp",
    "breakdownTitle": "Chi tiết giảm giá",
    "breakdownAria": "Giảm {{amount}} ({{source}}). Bấm để xem chi tiết."
  },

  "tabs": {
    "overview": "Thông tin chung",
    "treatment": "Dịch vụ điều trị",
    "progress": "Tiến trình điều trị",
    "payment": "Lịch sử thanh toán",
    "ariaLabel": "Các tab chi tiết kế hoạch điều trị"
  },

  "sections": {
    "basicInformation": "Thông tin cơ bản",
    "generalInformation": "Thông tin chung",
    "pricingAndDuration": "Giá và thời lượng",
    "procedureSteps": "Thao tác điều trị",
    "materialLines": "Định mức vật tư (BOM)",
    "additionalNotes": "Ghi chú thêm",
    "overview": "Tổng quan",
    "description": "Mô tả",
    "context": "Thông tin liên quan",
    "clinicalExecution": "Thực hiện lâm sàng",
    "sessionDetails": "Chi tiết lần thực hiện",
    "linkToTreatmentPlan": "Liên kết kế hoạch điều trị",
    "visitServices": "Dịch vụ trong buổi",
    "financialSummary": "Tổng kết tài chính",
    "paymentHistory": "Lịch sử thanh toán",
    "planItems": "Dịch vụ điều trị",
    "planItemsCount": "Hạng mục kế hoạch ({{count}})",
    "treatmentPlan": "Kế hoạch điều trị",
    "treatmentProgress": "Tiến trình điều trị"
  },

  "table": {
    "service": "Dịch vụ",
    "category": "Danh mục",
    "uom": "ĐVT",
    "warranty": "Bảo hành",
    "duration": "Thời lượng",
    "durationMins": "Thời lượng (phút)",
    "step": "Thao tác",
    "countsTowardKpi": "Đếm KPI",
    "price": "Giá",
    "status": "Trạng thái",
    "actions": "Thao tác",
    "planCode": "Mã kế hoạch",
    "patient": "Bệnh nhân",
    "catalogItems": "Dịch vụ",
    "representativeDoctor": "Bác sĩ đại diện",
    "totalCost": "Cần thanh toán",
    "paid": "Đã trả",
    "balance": "Còn lại",
    "payment": "Thanh toán",
    "code": "Mã",
    "qty": "SL",
    "teeth": "Răng",
    "assignedDentist": "Bác sĩ điều trị",
    "unitPrice": "Đơn giá",
    "discount": "Giảm giá",
    "lineTotal": "Thành tiền",
    "lab": "Lab",
    "description": "Mô tả",
    "notes": "Ghi chú",
    "createdBy": "Người tạo",
    "updatedBy": "Người cập nhật",
    "createdAt": "Ngày tạo",
    "updatedAt": "Cập nhật",
    "procedureSteps": "Quy trình",
    "materials": "Vật tư",
    "sessions": "Số lần",
    "title": "Tiêu đề",
    "performed": "Ngày thực hiện",
    "dentist": "Bác sĩ",
    "assistant": "Phụ tá",
    "innerAssistant": "Vòng trong",
    "outerAssistant": "Vòng ngoài",
    "notes": "Ghi chú"
  },

  "validation": {
    "nameRequired": "Vui lòng nhập tên dịch vụ",
    "codeRequired": "Vui lòng nhập mã dịch vụ",
    "categoryRequired": "Vui lòng chọn danh mục",
    "descriptionRequired": "Vui lòng nhập mô tả",
    "priceRequired": "Vui lòng nhập giá",
    "pricePositive": "Đơn giá không được âm",
    "priceMax": "Đơn giá không được lớn hơn {{max}}",
    "durationRequired": "Vui lòng nhập thời lượng",
    "durationPositive": "Thời lượng không được âm",
    "durationMax": "Thời lượng không được lớn hơn {{hours}} giờ",
    "warrantyMonthsRequired": "Vui lòng nhập số tháng bảo hành",
    "warrantyMonthsPositive": "Số tháng bảo hành phải là số nguyên từ 1 trở lên",
    "uomRequired": "Vui lòng chọn đơn vị tính",
    "assistantStaffingRequired": "Vui lòng chọn kíp 2 vòng",
    "workPerformerRequired": "Vui lòng chọn người làm",
    "categoryInvalid": "Danh mục không hợp lệ. Vui lòng chọn: {{list}}",
    "procedureStepTitleRequired": "Mỗi bước quy trình phải có tiêu đề",
    "procedureStepDurationInvalid": "Thời lượng bước phải lớn hơn hoặc bằng 0",
    "patientRequired": "Vui lòng chọn bệnh nhân",
    "planNameRequired": "Vui lòng nhập tên kế hoạch",
    "customerClassRequired": "Vui lòng chọn phân loại khách hàng",
    "planCreatedOnRequired": "Vui lòng chọn ngày tạo kế hoạch",
    "planItemRequired": "Vui lòng chọn một hạng mục kế hoạch điều trị",
    "planRequiredForVisit": "Cần mở ghi nhận buổi từ một kế hoạch điều trị",
    "serviceRequired": "Vui lòng chọn dịch vụ",
    "visitItemsRequired": "Vui lòng chọn ít nhất một dịch vụ trong buổi",
    "titleRequired": "Vui lòng nhập tiêu đề",
    "clinicalContentRequired": "Vui lòng nhập nội dung dịch vụ",
    "performedDateRequired": "Vui lòng chọn ngày thực hiện",
    "performedDateInvalid": "Ngày thực hiện không hợp lệ",
    "procedureStepRequired": "Vui lòng chọn bước quy trình của dịch vụ",
    "performerRequired": "Vui lòng chọn bác sĩ điều trị"
  },

  "dialogs": {
    "deleteCatalogItemTitle": "Ngừng dùng dịch vụ",
    "deleteCatalogItemConfirm": "Bạn có chắc muốn ngừng dùng \"{{name}}\"? Dịch vụ sẽ không còn xuất hiện khi chọn mới.",
    "confirmItemTitle": "Xác nhận",
    "confirmItemBody": "Xác nhận dịch vụ \"{{name}}\"?",
    "confirmTreatmentsTitle": "Xác nhận điều trị",
    "confirmTreatmentsBody": "Xác nhận {{count}} dịch vụ chưa xác nhận trong kế hoạch này?",
    "unconfirmTreatmentTitle": "Hủy xác nhận",
    "unconfirmTreatmentBody": "Hủy xác nhận dịch vụ \"{{name}}\"? Dịch vụ sẽ trở lại trạng thái chưa xác nhận.",
    "deletePlanTitle": "Xóa kế hoạch điều trị",
    "deletePlanConfirm": "Bạn có chắc chắn muốn xóa kế hoạch điều trị của \"{{name}}\"? Hành động này không thể hoàn tác.",
    "rejectPlanTitle": "Từ chối kế hoạch",
    "rejectPlanBody": "Mọi dịch vụ chưa xác nhận trong kế hoạch sẽ chuyển sang Từ chối.",
    "rejectionReasonPlaceholder": "Nhập lý do khách không nhận kế hoạch",
    "deleteSessionTitle": "Xóa buổi điều trị",
    "deleteSessionConfirm": "Bạn có chắc chắn muốn xóa \"{{title}}\"? Hành động này không thể hoàn tác."
  },

  "toasts": {
    "loadCatalogFailed": "Không thể tải danh mục dịch vụ",
    "loadCatalogItemFailed": "Không thể tải dịch vụ",
    "loadCatalogItemFailedRetry": "Không thể tải dịch vụ. Vui lòng thử lại.",
    "loadCatalogDataFailedRetry": "Không thể tải dữ liệu dịch vụ. Vui lòng thử lại.",
    "deleteCatalogItemSuccess": "Xóa dịch vụ thành công",
    "deleteCatalogItemFailed": "Không thể xóa dịch vụ",
    "deactivateCatalogItemSuccess": "Đã ngừng dùng dịch vụ",
    "deactivateCatalogItemFailed": "Không ngừng dùng được dịch vụ",
    "addCatalogItemSuccess": "Thêm dịch vụ thành công!",
    "addCatalogItemFailed": "Không thể thêm dịch vụ. Vui lòng thử lại.",
    "updateCatalogItemSuccess": "Cập nhật dịch vụ thành công!",
    "updateCatalogItemFailed": "Không thể cập nhật dịch vụ. Vui lòng thử lại.",
    "catalogExported": "Đã xuất CSV",
    "catalogExportFailed": "Không xuất được CSV",
    "catalogImported": "Đã nhập danh mục thành công",
    "catalogImportedPartial": "Đã nhập các dòng hợp lệ. Dòng lỗi được bỏ qua.",
    "catalogImportFailed": "Không nhập được file",
    "catalogTemplateFailed": "Không tải được file mẫu",

    "loadPlansFailed": "Không thể tải danh sách kế hoạch điều trị",
    "loadPlansFailedRetry": "Không thể tải danh sách kế hoạch điều trị. Vui lòng thử lại.",
    "loadPlanFailed": "Không thể tải kế hoạch điều trị",
    "loadPlanFailedRetry": "Không thể tải kế hoạch điều trị. Vui lòng thử lại.",
    "deletePlanSuccess": "Xóa kế hoạch điều trị thành công!",
    "deletePlanFailed": "Không thể xóa kế hoạch điều trị",
    "planRejected": "Đã từ chối kế hoạch điều trị",
    "rejectPlanFailed": "Không từ chối được kế hoạch điều trị",
    "savePlanFailed": "Không thể lưu kế hoạch điều trị",
    "createPlanSuccess": "Tạo kế hoạch điều trị thành công!",
    "createAndConfirmPlanSuccess": "Đã tạo kế hoạch và xác nhận hạng mục",
    "createPlanConfirmFailed": "Đã tạo kế hoạch nhưng chưa xác nhận được hạng mục",
    "updatePlanSuccess": "Cập nhật kế hoạch điều trị thành công!",
    "selectPatientRequired": "Vui lòng chọn bệnh nhân",
    "loadPatientsFailed": "Không thể tải danh sách bệnh nhân",
    "loadStaffFailed": "Không thể tải danh sách nhân viên",

    "loadPlanItemsFailed": "Không thể tải hạng mục kế hoạch",
    "itemAddedSuccess": "Đã thêm hạng mục vào kế hoạch",
    "itemsAddedSuccess": "Đã thêm {{count}} dịch vụ vào kế hoạch",
    "itemAddFailed": "Không thể thêm hạng mục",
    "itemRemovedSuccess": "Đã xóa hạng mục",
    "itemRemoveFailed": "Không thể xóa hạng mục",
    "itemUpdateFailed": "Không thể cập nhật hạng mục",
    "itemUpdateSuccess": "Đã cập nhật hạng mục",
    "itemConfirmed": "Đã xác nhận điều trị",
    "itemConfirmFailed": "Không xác nhận được điều trị",
    "itemUnconfirmed": "Đã hủy xác nhận",
    "itemUnconfirmFailed": "Không hủy xác nhận được",

    "loadSessionsFailed": "Không thể tải danh sách phiên điều trị",
    "loadSessionsFailedRetry": "Không thể tải danh sách phiên điều trị. Vui lòng thử lại.",
    "loadSessionFailed": "Không thể tải phiên điều trị",
    "loadPlanItemForPrefillFailed": "Không thể tải hạng mục kế hoạch để điền sẵn",
    "sessionAddedSuccess": "Đã thêm phiên điều trị",
    "sessionAddFailed": "Không thể thêm phiên điều trị",
    "sessionsAddedFromProceduresSuccess": "Đã thêm phiên từ quy trình",
    "sessionsAddFailed": "Không thể thêm phiên điều trị",
    "sessionRemovedSuccess": "Đã xóa phiên điều trị",
    "sessionRemoveFailed": "Không thể xóa phiên điều trị",
    "sessionUpdateFailed": "Không thể cập nhật phiên điều trị",
    "deleteSessionSuccess": "Xóa phiên điều trị thành công!",
    "deleteSessionFailed": "Không thể xóa phiên điều trị",
    "createSessionSuccess": "Tạo lần thực hiện thành công!",
    "createSessionFailed": "Không thể tạo lần thực hiện",
    "recordVisitSuccess": "Đã ghi nhận buổi điều trị.",
    "recordVisitFailed": "Không thể ghi nhận buổi điều trị",
    "updateSessionSuccess": "Cập nhật lần thực hiện thành công!",
    "updateSessionFailed": "Không thể cập nhật lần thực hiện"
  },

  "empty": {
    "noCatalogItems": "Không tìm thấy dịch vụ phù hợp",
    "noCatalogItemsYet": "Chưa có dịch vụ trong danh mục",
    "noPlansMatch": "Không có kế hoạch điều trị nào khớp với tìm kiếm",
    "noPlansTitle": "Chưa có kế hoạch điều trị",
    "noPlansDescription": "Tạo kế hoạch điều trị đầu tiên để quản lý quy trình điều trị của bệnh nhân.",
    "noItemsInPlan": "Không có hạng mục nào trong kế hoạch này",
    "noItemsYet": "Chưa có hạng mục nào trong kế hoạch",
    "noSessionsMatch": "Không có buổi điều trị nào khớp với tìm kiếm",
    "noSessionsTitle": "Chưa có buổi điều trị",
    "noSessionsDescription": "Ghi nhận buổi điều trị từ trang kế hoạch điều trị của bệnh nhân.",
    "addFirstSession": "Mở kế hoạch điều trị",
    "goToPlansToRecord": "Mở danh sách kế hoạch để ghi nhận buổi",
    "noProcedureSteps": "Chưa có bước quy trình nào",
    "noProcedureStepsAdded": "Chưa có bước quy trình nào được thêm.",
    "noMaterialLines": "Chưa có định mức vật tư. Thêm dòng nếu dịch vụ cần trừ kho / hoa hồng.",
    "noServicesFound": "Không tìm thấy dịch vụ",
    "typeToSearchServices": "Nhập để tìm dịch vụ",
    "noMatchingServices": "Không có dịch vụ phù hợp",
    "noSessionsDefined": "Chưa có buổi điều trị gắn dịch vụ này"
  },

  "actions": {
    "refresh": "Làm mới",
    "addCatalogItem": "Thêm dịch vụ",
    "deactivateCatalogItem": "Ngừng dùng",
    "saveTreatment": "Lưu dịch vụ",
    "updateTreatment": "Cập nhật",
    "updatingTreatment": "Đang cập nhật...",
    "backToTreatments": "Quay lại danh sách dịch vụ",
    "addStep": "Thêm bước",
    "addMaterialLine": "Thêm vật tư",
    "issueMaterials": "Xuất vật tư",
    "moreActions": "Thêm thao tác",
    "moveStepUp": "Di chuyển bước lên",
    "moveStepDown": "Di chuyển bước xuống",
    "removeStep": "Xóa bước",
    "create": "Tạo kế hoạch",
    "creating": "Đang tạo...",
    "createAndConfirm": "Tạo và xác nhận",
    "creatingAndConfirming": "Đang tạo và xác nhận...",
    "createOptions": "Các cách tạo",
    "createPlan": "Tạo kế hoạch điều trị",
    "createFirstPlan": "Tạo kế hoạch điều trị đầu tiên",
    "backToPlans": "Quay lại kế hoạch điều trị",
    "recordPayment": "Thu dịch vụ",
    "recordPlanAdvance": "Tạm ứng",
    "recordPlanAdvanceRefund": "Hoàn tạm ứng",
    "confirmTreatment": "Xác nhận",
    "confirmingTreatment": "Đang xác nhận...",
    "confirmAllTreatments": "Xác nhận điều trị",
    "confirmingTreatments": "Đang xác nhận...",
    "unconfirmTreatment": "Hủy xác nhận",
    "unconfirmingTreatment": "Đang hủy xác nhận...",
    "createLabOrder": "Tạo đơn lab",
    "labOrderSent": "Đã gửi lab",
    "viewLabOrder": "Xem đơn lab",
    "remakeLabOrder": "Làm lại",
    "updatePlan": "Cập nhật kế hoạch",
    "updatingPlan": "Đang cập nhật...",
    "browseAllServices": "Xem tất cả dịch vụ…",
    "searchAndAddService": "Tìm và thêm dịch vụ",
    "addSession": "Thêm lần thực hiện",
    "addFromProcedures": "Thêm từ quy trình",
    "addTreatmentSession": "Ghi nhận buổi điều trị",
    "recordVisit": "Ghi nhận buổi",
    "rejectPlan": "Từ chối",
    "rejectingPlan": "Đang từ chối...",
    "recordVisitForService": "Ghi nhận cho dịch vụ này",
    "createSession": "Ghi nhận",
    "saveChanges": "Lưu thay đổi",
    "viewPatientProfile": "Xem hồ sơ bệnh nhân"
  },

  "picker": {
    "title": "Xem tất cả dịch vụ",
    "searchServices": "Tìm dịch vụ",
    "name": "Tên",
    "code": "Mã",
    "category": "Danh mục",
    "uom": "ĐVT",
    "price": "Giá",
    "duration": "Thời lượng",
    "action": "Hành động",
    "service": "Dịch vụ",
    "selectAll": "Chọn tất cả",
    "unselectAll": "Bỏ chọn tất cả",
    "addSelected": "Thêm ({{count}})",
    "noServicesFound": "Không tìm thấy dịch vụ",
    "withProcedureSteps": "Có bước quy trình"
  },

  "sessionsPanel": {
    "title": "Buổi gắn dịch vụ này ({{count}})",
    "sessionTitlePlaceholder": "Tiêu đề...",
    "newSessionDefaultTitle": "Lần thực hiện mới"
  },

  "catalog": {
    "title": "Danh mục dịch vụ",
    "addTitle": "Thêm dịch vụ",
    "editTitle": "Sửa dịch vụ",
    "viewTitle": "Chi tiết dịch vụ",
    "history": {
      "action": "Lịch sử",
      "title": "Lịch sử",
      "empty": "Chưa có lịch sử thay đổi cho dịch vụ này."
    },
    "permissionDenied": "Bạn không có quyền xem danh mục dịch vụ.",
    "searchPlaceholder": "Tìm theo tên hoặc mã dịch vụ…",
    "statusFilter": {
      "aria": "Lọc theo trạng thái",
      "all": "Tất cả",
      "active": "Đang dùng",
      "inactive": "Ngừng dùng"
    },
    "stepsCount": "{{count}} bước",
    "notFound": "Không tìm thấy dịch vụ",
    "noDescription": "Chưa có mô tả.",
    "noProcedureSteps": "Chưa có bước quy trình nào.",
    "procedureStepsCount": "Các bước quy trình ({{count}})",
    "durationMinutes": "{{count}} phút",
    "formTabsAria": "Các phần form dịch vụ",
    "procedureStepsHeading": "Thao tác điều trị",
    "copySteps": {
      "action": "Sao chép từ dịch vụ…",
      "pickerTitle": "Sao chép bước quy trình",
      "select": "Chọn",
      "empty": "Không có dịch vụ nào có bước quy trình",
      "replaceTitle": "Thay thế các bước hiện tại?",
      "replaceMessage": "Dịch vụ “{{name}}” có {{count}} bước. Thao tác này thay {{current}} bước đang nhập.",
      "replaceConfirm": "Thay thế",
      "copied": "Đã sao chép {{count}} bước từ {{name}}",
      "noneToCopy": "Dịch vụ này không còn bước hợp lệ"
    },
    "placeholders": {
      "name": "Cạo vôi răng",
      "category": "Chọn danh mục",
      "warrantyType": "Chọn bảo hành",
      "assistantStaffing": "Chọn kíp 2 vòng",
      "workPerformer": "Chọn người làm",
      "defaultLabWorkType": "Chọn loại phục hình",
      "defaultLabMaterial": "Chọn vật liệu lab",
      "price": "{{min}} - {{max}}",
      "duration": "{{min}} - {{max}}"
    },
    "descriptionPlaceholder": "Nhập mô tả chi tiết về dịch vụ",
    "materialLinesHint": "Vật tư bắt buộc phải được xuất kho (ghi sổ) trước khi hệ thống trừ chi phí vào hoa hồng.",
    "notesPlaceholder": "Thêm ghi chú hoặc hướng dẫn bổ sung cho dịch vụ này",
    "selectUom": "Chọn đơn vị tính",
    "assistantStaffing": {
      "none": "Không",
      "single": "Không",
      "inner_outer": "Có (trong / ngoài)"
    },
    "workPerformer": {
      "dentist": "Bác sĩ",
      "assistant": "Phụ tá"
    },
    "countsTowardKpiYes": "Đếm KPI",
    "countsTowardKpiNo": "Không đếm",
    "warranty": {
      "none": "Không bảo hành",
      "fixedTerm": "Theo tháng",
      "lifetime": "Trọn đời",
      "monthsCount": "{{count}} tháng",
      "status": {
        "pending": "Chờ kích hoạt",
        "active": "Còn BH đến {{date}}",
        "expired": "Hết BH {{date}}",
        "lifetime": "BH trọn đời"
      }
    },
    "stepTitlePlaceholder": "Gây tê tại chỗ",
    "stepMinsPlaceholder": "15",
    "stepDescriptionPlaceholder": "Mô tả",
    "actions": {
      "export": "Xuất CSV",
      "import": "Nhập file"
    },
    "dialogs": {
      "importTitle": "Nhập danh mục dịch vụ"
    },
    "importExport": {
      "hintRequired": "Bắt buộc: tên dịch vụ, tên nhóm, giá, thời lượng (phút).",
      "hintGroup": "Tên nhóm so với nhóm hiện có, không phân biệt hoa thường, kể cả nhóm đang ngừng dùng. Chưa có thì hệ thống tự tạo nhóm mới.",
      "hintCode": "Có mã dịch vụ thì cập nhật; để trống thì tạo mới (hệ thống cấp SV###). Đơn vị tính không bắt buộc.",
      "hintMapping": "Tên cột không cần giống file mẫu — hãy ghép cột sau khi chọn file, rồi bấm Kiểm tra.",
      "hintSheet": "File Excel: chỉ nhập sheet đầu tiên; các sheet khác bị bỏ qua.",
      "chooseFile": "Chọn file CSV hoặc Excel",
      "dropHint": "Nhấn để chọn hoặc kéo thả file CSV hoặc Excel",
      "acceptHint": "CSV hoặc Excel (.xlsx), tối đa 5MB / 5000 dòng. Excel: chỉ đọc sheet đầu.",
      "invalidFile": "Vui lòng chọn file CSV hoặc Excel (.xlsx)",
      "changeFile": "Đổi file",
      "commit": "Nhập dữ liệu",
      "downloadTemplate": "Tải file mẫu",
      "downloadErrors": "Tải dòng lỗi (CSV)",
      "errorsCsvFilename": "danh-muc-dich-vu-loi.csv",
      "noFile": "Vui lòng chọn file CSV hoặc Excel",
      "previewTitle": "Kết quả kiểm tra",
      "total": "Tổng dòng",
      "toCreate": "Sẽ tạo mới",
      "toUpdate": "Sẽ cập nhật",
      "errorsTitle": "Lỗi",
      "row": "Dòng",
      "code": "Mã",
      "message": "Chi tiết",
      "readyToCommit": "File hợp lệ. Bạn có thể nhập dữ liệu.",
      "hasErrors": "File còn lỗi. Sửa rồi kiểm tra lại trước khi nhập.",
      "resultTitle": "Kết quả nhập",
      "created": "Đã tạo",
      "updated": "Đã cập nhật",
      "uploading": "Đang tải file…",
      "checking": "Đang kiểm tra file…",
      "checkingWithCount": "Đang kiểm tra {{count}} dòng…",
      "importing": "Đang nhập dữ liệu…",
      "importingWithCount": "Đang nhập {{count}} dòng…",
      "confirmUpdateTitle": "Xác nhận cập nhật",
      "confirmUpdateMessage": "Sẽ cập nhật {{count}} dịch vụ hiện có. Tiếp tục?",
      "confirmUpdateConfirm": "Cập nhật",
      "skipInvalidRows": "Bỏ qua dòng lỗi và nhập các dòng hợp lệ",
      "skipSummary": "Bỏ qua {{errors}} dòng lỗi, nhập {{importCount}} dòng.",
      "partialResult": "Đã nhập các dòng hợp lệ. Dòng lỗi được bỏ qua.",
      "confirmSkipTitle": "Nhập và bỏ qua dòng lỗi",
      "confirmSkipMessage": "Bỏ qua {{errors}} dòng lỗi. Sẽ tạo {{create}} và cập nhật {{update}} dịch vụ. Tiếp tục?",
      "confirmSkipConfirm": "Nhập dữ liệu",
      "fields": {
        "code": "Mã dịch vụ",
        "name": "Tên dịch vụ",
        "categoryName": "Tên nhóm",
        "description": "Mô tả",
        "price": "Giá",
        "duration": "Thời lượng (phút)",
        "uom": "Đơn vị",
        "warrantyType": "Loại bảo hành",
        "warrantyMonths": "Tháng bảo hành",
        "labOrderEnabled": "Chỉ định labo",
        "defaultLabWorkType": "Loại labo",
        "defaultLabMaterial": "Vật liệu labo",
        "notes": "Ghi chú",
        "isActive": "Đang dùng"
      },
      "rowErrors": {
        "CODE_TOO_LONG": "Mã dịch vụ không được vượt quá {{max}} ký tự.",
        "DUPLICATE_CODE": "Mã dịch vụ bị trùng trong file.",
        "NAME_REQUIRED": "Thiếu tên dịch vụ.",
        "NAME_TOO_LONG": "Tên dịch vụ không được vượt quá {{max}} ký tự.",
        "DESCRIPTION_TOO_LONG": "Mô tả không được vượt quá {{max}} ký tự.",
        "NOTES_TOO_LONG": "Ghi chú không được vượt quá {{max}} ký tự.",
        "PRICE_INVALID": "Giá phải từ 0 đến {{max}}.",
        "DURATION_INVALID": "Thời lượng phải từ 0 đến {{max}} phút ({{hours}} giờ).",
        "LAB_ORDER_INVALID": "Cột labOrderEnabled phải là true hoặc false.",
        "ASSISTANT_STAFFING_INVALID": "Cột assistantStaffing phải là none, single hoặc inner_outer.",
        "WORK_PERFORMER_INVALID": "Cột workPerformer phải là dentist hoặc assistant.",
        "WARRANTY_TYPE_INVALID": "Cột warrantyType phải là months hoặc lifetime (để trống nếu không bảo hành).",
        "WARRANTY_MONTHS_INVALID": "Cột warrantyMonths phải là số nguyên từ 1 đến 1200 khi warrantyType là months.",
        "LAB_WORK_TYPE_INVALID": "Cột defaultLabWorkType không hợp lệ.",
        "LAB_MATERIAL_INVALID": "Cột defaultLabMaterial không hợp lệ.",
        "IS_ACTIVE_INVALID": "Cột isActive phải là true hoặc false.",
        "CATEGORY_REQUIRED": "Thiếu tên nhóm dịch vụ.",
        "CATEGORY_NAME_TOO_LONG": "Tên nhóm không được vượt quá {{max}} ký tự.",
        "CATEGORY_UNKNOWN": "Không tìm thấy nhóm {{categoryName}}.",
        "CATEGORY_INACTIVE": "Nhóm {{categoryName}} đang ngừng dùng.",
        "UOM_INVALID": "Đơn vị tính không hợp lệ.",
        "UOM_INACTIVE": "Đơn vị tính đang ngừng dùng."
      }
    },
    "panel": {
      "categoriesTitle": "Nhóm dịch vụ",
      "scopeSection": "Phạm vi",
      "categoriesSection": "Danh sách nhóm A–Z",
      "allCategories": "Tất cả",
      "unassigned": "Chưa gán nhóm",
      "noCategories": "Chưa có nhóm. Thêm nhóm để phân loại dịch vụ."
    }
  },

  "filters": {
    "patient": "Bệnh nhân"
  },

  "plan": {
    "title": "Kế hoạch điều trị",
    "detailsTitle": "Chi tiết kế hoạch điều trị",
    "addTitle": "Tạo kế hoạch điều trị",
    "editTitle": "Sửa kế hoạch điều trị",
    "permissionDenied": "Bạn không có quyền xem kế hoạch điều trị.",
    "searchPlaceholder": "Tìm theo mã kế hoạch hoặc bệnh nhân…",
    "notFound": "Không tìm thấy kế hoạch điều trị",
    "noDescription": "Chưa có mô tả.",
    "notAssigned": "Chưa gán",
    "itemsCount": "{{count}} dịch vụ",
    "representativeDoctorOptional": "Bác sĩ đại diện",
    "consultantOptional": "Bác sĩ tư vấn",
    "consultingStaffOptional": "Nhân viên tư vấn",
    "representativeDoctorPlaceholder": "Chọn bác sĩ đại diện",
    "consultantPlaceholder": "Chọn bác sĩ tư vấn",
    "consultingStaffPlaceholder": "Chọn nhân viên tư vấn",
    "descriptionPlaceholder": "Nhập thông tin chẩn đoán và mô tả kế hoạch điều trị",
    "namePlaceholder": "Kế hoạch điều trị 1",
    "promotionSection": "Khuyến mãi",
    "promotionLabel": "Chương trình KM",
    "promotionHelperEditable": "Chọn KM giảm giá kế hoạch",
    "updatePromotion": "Cập nhật khuyến mãi",
    "chooseOffer": "Chọn ưu đãi",
    "offerProgram": "Chương trình",
    "offerManual": "Nhập tay",
    "offerFixed": "Số tiền",
    "offerFixedSymbol": "đ",
    "offerPercent": "%",
    "offerFixedPlaceholder": "Nhập số tiền",
    "offerPercentPlaceholder": "Nhập %",
    "offerReason": "Lý do",
    "offerReasonPlaceholder": "Lý do (không bắt buộc)",
    "offerManualCaption": "Nhập tay",
    "offerPercentCaption": "{{value}}% · Nhập tay",
    "offerExceedsBase": "Không vượt quá {{max}}",
    "offerPercentRange": "Từ 1 đến 100",
    "promotionHelperLocked": "KM toàn kế hoạch đã gắn dòng đã thu tiền thì không reverse/đổi được. Có thể thêm ưu đãi mới cho dòng chưa thu.",
    "itemsHelperLocked": "Không thể chỉnh sửa giá/ưu đãi trên dòng dịch vụ đã phát sinh thanh toán.",
    "promotionDiscountLabel": "Giảm KM",
    "promotionApplyFailed": "Không áp dụng được KM",
    "serviceDiscountAvailableTooltip": "{{name}} — giảm {{amount}}. Bấm để áp dụng.",
    "serviceDiscountApply": "Áp dụng",
    "serviceDiscountPreviewFailed": "Không kiểm tra được KM dịch vụ",
    "totalLabel": "Phải thanh toán",
    "quotedLabel": "Dự kiến thu",
    "noCatalogPermission": "Bạn không có quyền truy cập danh mục dịch vụ. Vui lòng liên hệ quản trị viên để thêm dịch vụ.",
    "searchServicePlaceholder": "Nhập tên hoặc mã dịch vụ...",
    "filterCatalog": "Tất cả dịch vụ",
    "collapseSessions": "Thu gọn buổi gắn dịch vụ này",
    "expandSessions": "Mở rộng buổi gắn dịch vụ này"
  },

  "session": {
    "title": "Buổi điều trị",
    "detailsTitle": "Chi tiết buổi điều trị",
    "addTitle": "Ghi nhận buổi điều trị",
    "recordVisitTitle": "Ghi nhận buổi điều trị",
    "editTitle": "Sửa buổi điều trị",
    "permissionDenied": "Bạn không có quyền xem buổi điều trị.",
    "createPermissionDenied": "Bạn không có quyền ghi nhận buổi điều trị.",
    "recordRequiresPlan": "Hãy mở ghi nhận buổi từ trang kế hoạch điều trị.",
    "recordVisitHint": "Bệnh nhân {{patient}} · Kế hoạch {{plan}}. Chọn dịch vụ hoặc bước quy trình, rồi ghi nội dung đã thực hiện.",
    "visitServicesHint": "Chọn dịch vụ đã thực hiện để cập nhật tiến độ.",
    "linkServicesOptional": "Dịch vụ trên kế hoạch",
    "linkServicesHint": "Chọn dịch vụ đã thực hiện. Nếu dịch vụ có quy trình, chọn bước trong cùng danh sách.",
    "sharedNotesOptional": "Ghi chú chung buổi (không bắt buộc)",
    "selectAllServices": "Chọn tất cả dịch vụ",
    "nextStepHint": "Tiếp theo",
    "noRecordableItems": "Chưa có hạng mục đã xác nhận để gắn công tác.",
    "searchPlaceholder": "Tìm theo tiêu đề, bệnh nhân, kế hoạch…",
    "notFound": "Không tìm thấy buổi điều trị",
    "showingForPatient": "Đang hiển thị buổi của bệnh nhân đã chọn.",
    "clearFilter": "Xóa bộ lọc",
    "planItemService": "Hạng mục kế hoạch (Dịch vụ)",
    "performingDentistOptional": "Bác sĩ thực hiện (không bắt buộc)",
    "performer": "Bác sĩ điều trị",
    "performerShort": "Bác sĩ",
    "performerPlaceholder": "Chọn bác sĩ điều trị",
    "servicePlaceholder": "Chọn dịch vụ",
    "performerOptional": "Người làm (không bắt buộc)",
    "twoRingKip": "Kíp 2 vòng",
    "twoRingShort": "2 vòng",
    "assistantOptional": "Phụ tá (không bắt buộc)",
    "innerAssistantOptional": "Phụ tá vòng trong (không bắt buộc)",
    "outerAssistantOptional": "Phụ tá vòng ngoài (không bắt buộc)",
    "assistantPlaceholder": "Chọn phụ tá",
    "innerAssistantPlaceholder": "Chọn phụ tá vòng trong",
    "outerAssistantPlaceholder": "Chọn phụ tá vòng ngoài",
    "noPlansForPatient": "Không tìm thấy kế hoạch điều trị cho bệnh nhân này.",
    "noItemsInPlan": "Không có hạng mục nào trong kế hoạch này. Vui lòng thêm hạng mục vào kế hoạch trước.",
    "clinicalStaff": {
      "dentist": "BS. {{name}}",
      "assistant": "PT. {{name}}"
    }
  },

  "pagination": {
    "rowsPerPage": "Số dòng mỗi trang:",
    "displayedRows": "{{from}}–{{to}} trong {{count}}",
    "moreThan": "hơn {{to}}"
  }
}
